import { useEffect } from "react";
import { useCurrentUser } from "@/features/account/useCurrentUser";
import { setTelemetryUser } from "./telemetry";

/** Tags error reports with the signed-in user's UUID (no PII). */
export function TelemetryUser() {
  const uuid = useCurrentUser().data?.user.uuid ?? null;
  useEffect(() => {
    setTelemetryUser(uuid);
    return () => setTelemetryUser(null);
  }, [uuid]);
  return null;
}
